<template>
	<img
		:src="runtimeConfig.public.IMAGES.LOADER"
		:class="customClass"
		alt="Loading..." />
</template>

<script setup>
	const runtimeConfig = useRuntimeConfig()
	defineProps({
		customClass: {
			type: String,
			default: "",
		},
	})
</script>
